import { IkasImage } from "../image";
import { IkasHTMLMetaData } from "../html-meta-data";
import { IkasBaseModel } from "../base";
import { IkasProductBrandTranslation } from "./translation";

export type IkasBrand = {
  description: string | null;
  imageId: string | null;
  name: string;
  metaData: IkasHTMLMetaData | null;
  orderType: IkasBrandOrderType | null;

  image?: IkasImage | null;
  translations?: IkasProductBrandTranslation[] | null;
} & IkasBaseModel;

export enum IkasBrandOrderType {
  BEST_SELLER = "BEST_SELLER",
  HIGHEST_DISCOUNT_RATIO = "HIGHEST_DISCOUNT_RATIO",
  HIGHEST_PRICE = "HIGHEST_PRICE",
  LOWEST_DISCOUNT_RATIO = "LOWEST_DISCOUNT_RATIO",
  LOWEST_PRICE = "LOWEST_PRICE",
  MANUALLY = "MANUALLY",
  NEWEST = "NEWEST",
  OLDEST = "OLDEST",
}
